module.exports = __webpack_public_path__ + "img/avatar.63a5c714.png";